<template>
    <b-card no-body class="location-view">
        <slot name="section"></slot>
        <b-card-body class="location-popup inner-page">
            <b-tabs align="center" card class="p-0" content-class="tabs" v-model="tabIdx">
                <b-tab :title="$translate('address')" :title-link-class="'fw-bold'" active>
                    <b-card-body class="p-0">
                        <b-form class="form-sample p-0 filter-form" @submit.stop.prevent="onSubmit">
                            <b-row>
                                <b-col v-for="(d_item, i) in dataItems" :key="i + 'data'" md="6" :class="{
                                    'd-flex align-items-end pb-2 gap-2': d_item.type === 'check' &&
                                        !sectionOnly, 'dd': d_item.field === 'state_name' || d_item.field === 'country_code'
                                }" class="mt-3" cols="12">
                                    <div class="form-check" v-if="d_item.type === 'check' && !sectionOnly">
                                        <label class="form-check-label me-3">
                                            <input type="checkbox" class="form-check-input top-2"
                                                :id="'input-' + d_item.field" :disabled="viewable"
                                                v-model="model[d_item.field]" :name="'input-' + d_item.field" :value="1"
                                                :unchecked-value="0" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label :for="'input-' + d_item.field"
                                        :class="{ 'mb-2': d_item.type === 'check', 'mb-3': d_item.type !== 'check' }"><strong>
                                            {{ $translate(d_item.field) }} <span v-if="d_item.required"
                                                class="red">*</span></strong>
                                    </label>
                                    <b-form-input v-if="d_item.type === 'text'" :id="'input-' + d_item.field"
                                        class="form-control lh-base" v-model="model[d_item.field]"
                                        :required="d_item.required"
                                        v-custom-validation="d_item.required ? $textRequired() : ''" :readonly="!!d_item.readonly
                                            " trim></b-form-input>
                                    <b-col v-if="d_item.field === 'country_code'">
                                        <b-form-select class="form-control" value-field="value"
                                            :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                            v-custom-validation="d_item.required ? $selectRequired() : ''"
                                            :required="d_item.required" @change="fetchState(d_item, $event)"
                                            :options="getData(d_item.field)">
                                            <template #first>
                                                <b-form-select-option :value="null">
                                                    {{ $translate('select_country') }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>

                                    <b-form-select class="form-control" v-if="d_item.field === 'state_name'"
                                        value-field="text" :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                        :required="d_item.required" :options="getData(d_item.field)"
                                        v-custom-validation="d_item.required ? $selectRequired() : ''">
                                        <template #first>
                                            <b-form-select-option :value="null" selected>
                                                {{ $translate('select_state') }}
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>

                            <b-form-row class="mt-4 mb-2">
                                <b-col class="d-flex justify-content-center gap-2">
                                    <b-button v-if="!hideControls && hasPermissionCreate && !model.id" type="submit"
                                        variant="info" class="btn-fw" :disabled="!!loading">{{ createLabel }}</b-button>
                                    <b-button v-if="!hideControls && hasPermissionUpdate && model.id" type="submit"
                                        variant="info" class="btn-fw" :disabled="!!loading">{{ updateLabel }}</b-button>

                                    <b-button v-if="!hideControls && this.model.id && hasPermissionDelete
                                        " @click="deleteLocation()" size="fw" variant="delete-button">
                                        {{ $translate("delete_location") }}
                                    </b-button>
                                    <b-button v-if="!hideControls" variant="info" class="btn-fw" :disabled="!!loading"
                                        @click="$router.go(-1)">{{ $translate("cancel") }}</b-button>
                                    <slot v-bind:default="model"></slot>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('map')" :title-link-class="'fw-bold'">
                    <b-card-body class="my-4 p-0">
                        <location-picker v-if="tabIdx == 1" :title="$translate('map_location')" :location="mapLocation"
                            @set-location="coords => setCoordinates(coords)" @get-location="locationdata => getLocation(locationdata)
                                " />
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('sections')" :title-link-class="'fw-bold'" v-if="!sectionOnly && !!model.id">
                    <b-card-body class="p-0">
                        <b-form class="form-sample p-0" inline>
                            <b-row class="my-3">
                                <label class="sr-only" for="inline-form-input-name">{{ $translate('section_name') }}</label>
                                <b-col cols="12" class="d-flex flex-nowrap">
                                    <div class="append-buttons">
                                        <b-form-input id="inline-form-input-name" class="mt-2 mt-md-0 lh-base"
                                            :placeholder="$translate('section_name')" v-model="section.name"></b-form-input>
                                    </div>
                                    <b-button class="mt-2 mt-md-0 ms-2" v-b-tooltip.hover :title="$addLabel()"
                                        variant="blue-icon" @click="saveSection(section)"><img
                                            src="@/assets/images/icon/gradient-add.svg"></b-button>
                                </b-col>
                            </b-row>
                        </b-form>

                        <b-table :fields="sectionFields" responsive striped hover :items="sections">
                            <template #cell(name)="row" class="sdsdsds">
                                <b-form-input :id="row.index + 'name'" v-model="row.item.name"></b-form-input>
                            </template>
                            <template #cell(is_officer)="row">
                                <div class="form-check me-2">
                                    <label class="form-check-label">
                                        <input type="checkbox" v-model="row.item.is_officer"
                                            :name="row.index + '-is_officer'" :value="1" :unchecked-value="0" />
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </template>
                            <template #cell(id)="row">
                                <div class="d-flex gap-2">
                                    <b-button variant="blue-icon" @click="saveSection(row.item)">
                                        <img src="@/assets/images/icon/save.svg">
                                    </b-button>
                                    <b-button @click="deleteSection(row.item.id)" class="mr-2" variant="blue-icon">
                                        <img src="@/assets/images/icon/delete.svg">
                                    </b-button>
                                </div>
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card-body>
    </b-card>
</template>

<script lang="js">
import { debounce } from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import LocationPicker from '@/components/Map/LocationPicker'

const dataItems = Object.freeze([{
    field: 'name',
    type: 'text',
    required: true
},
{
    field: 'is_warehouse',
    type: 'check',
    required: false
},
{
    field: 'country_code',
    type: 'select',
    required: true
},
{
    field: 'county',
    type: 'text',
    required: false
},
{
    field: 'address1',
    type: 'text',
    required: true
},
{
    field: 'address2',
    type: 'text',
    required: false
},
{
    field: 'state_name',
    type: 'select',
    required: true
},
{
    field: 'city',
    type: 'text',
    required: true
},
{
    field: 'postal_code',
    type: 'text',
    required: false
},
{
    field: 'zip_code',
    type: 'text',
    required: false
},
{
    field: 'latitude',
    type: 'text',
    readonly: true,
    required: false
},
{
    field: 'longitude',
    type: 'text',
    readonly: true,
    required: false
},
])

const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            switch (item.field) {
                case 'country_code':
                    _form.country_code = 'JM'
                    break
                default:
                    _form[item.field] = item.type == 'check' ? false : null
                    break
            }
            return _form
        }, {
        id: 0
    }
    )
}

const L = window.L
const model = generateEmptyForm()
const default_coords = {
    latitude: 18.002804952844535,
    longitude: -76.78970255393327,
}
/////default

export default {
    name: 'locations-view',
    components: {
        LocationPicker
    },
    data() {
        return {
            tabIdx: 0,
            updatedDataItems: [],
            model,
            hasErrors: false,
            section: {
                name: null
            },
        }
    },
    props: {
        id: {
            type: Number,
            default: 0
        },
        sectionOnly: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        hideControls: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        locationData: {
            type: Object,
            default: () => null,
        },
    },
    mixins: [popupMixins, permissionsMixins],
    computed: {
        sectionFields() {
            return [
                { key: "name", label: this.$translate("name") },
                { key: "is_officer", label: this.$translate("is_officer") },
                {
                    key: 'id',
                    label: this.$translate('controls'),
                },
            ]
        },
        isReadOnly() {
            return !!(this.sectionOnly && this.model.id)
        },
        viewable() {
            return !!this.model.id
        },
        dataItems() {
            return [...dataItems].filter(
                x =>
                    !(
                        (x.field === 'name' || x.field === 'is_warehouse') &&
                        this.sectionOnly
                    )
            )
        },
        title() {
            return this.model.id ? 'Edit Location' : 'Add Location'
        },
        locationRoute() {
            return this.$route.name.slice(0, 8) === 'location'
        },
        sections() {
            return this.$store.getters['locations/sections']
        },

        simpleLocation() {
            return this.$store.getters['locations/simpleLocation']
        },
        mapLocation() {
            const _location = {
                ...(this.model || {})
            }
            let {
                latitude,
                longitude
            } = _location
            latitude = isNaN(parseFloat(latitude)) ? default_coords.latitude : parseFloat(latitude)
            longitude = isNaN(parseFloat(longitude)) ? default_coords.longitude : parseFloat(longitude)
            try {
                if (
                    !(
                        latitude > -90 &&
                        latitude < 90 &&
                        longitude > -180 &&
                        longitude < 180
                    )
                ) {
                    console.log('invalid coordinates', {
                        latitude,
                        longitude,
                    })
                    throw new Error('Invalid Coordinates')
                }
            } catch (error) {
                console.error('mapLocation', error)
                ////////
                latitude = default_coords.latitude
                longitude = default_coords.longitude
            }

            const center = new L.latLng(latitude, longitude)
            this.$set(_location, 'lat', latitude)
            this.$set(_location, 'lng', longitude)
            this.$set(_location, 'center', center)
            return _location
        },

        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
    },
    watch: {
        sections: {
            handler: function () { },
            deep: true,
        },
        simpleLocation: {
            handler: function (_location) {
                this.model = {
                    ..._location
                }
            },
            deep: true,
        },

        'model.name': debounce(function (val) {
            this.$set(this.model, 'name', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.is_warehouse': function (val) {
            this.$set(this.model, 'is_warehouse', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        },

        'model.address1': debounce(function (val) {
            this.$set(this.model, 'address1', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.address2': debounce(function (val) {
            this.$set(this.model, 'address2', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.city': debounce(function (val) {
            this.$set(this.model, 'city', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),
        'model.state_name': debounce(function (val) {
            this.$set(this.model, 'state_name', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.postal_code': debounce(function (val) {
            this.$set(this.model, 'postal_code', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.country_code': function (val) {
            //this.$store.dispatch('locations/fetchstate', { val })
            this.$set(this.model, 'country_code', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        },

        // 'model.map_reference': debounce(function (val) {
        //     this.$set(this.model, 'map_reference', val)
        //     this.$nextTick(() => {
        //         this.fetchCoordinates()
        //     })
        // }, 500),

        id: function (id) {
            this.setLocation(id).then()
        },
        locationData: function (_data) {
            this.setLocation(this.id, _data)
        },
    },

    async mounted() {
        await this.setLocation(this.id, this.locationData)
        const country_code = await this.model.country_code
        this.$store.dispatch('locations/fetchstate', { country_code })
    },
    created() {
        // this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchCountry')
    },

    methods: {
        clearModel() {
            this.model = generateEmptyForm()
        },
        async setLocation(id, data) {
            try {
                if (id) {
                    await this.$store.dispatch('locations/fetchById', id)
                    await this.$nextTick()
                    this.model = {
                        ...this.simpleLocation
                    }
                } else if (data) {
                    this.model = {
                        ...data
                    }
                } else {
                    this.clearModel()
                }
            } catch (error) {
                this.isError = true
            }
        },
        setCoordinates(coords) {
            const {
                lat: latitude,
                lng: longitude
            } = coords
            if (!this.isReadOnly) {
                this.$set(this.model, 'latitude', latitude)
                this.$set(this.model, 'longitude', longitude)
            }
        },

        getLocation(locationData) {
            const country_code = locationData.data.results[0].components.country_code.toUpperCase()
            this.$set(this.model, 'city', locationData.data.results[0].components.city)
            this.$set(this.model, 'state_name', locationData.data.results[0].components.state)
            this.$set(this.model, 'county', locationData.data.results[0].components.county)
            this.$set(this.model, 'country_code', locationData.data.results[0].components.country_code.toUpperCase())
            this.$store.dispatch('locations/fetchstate', { country_code })
            this.$set(this.model, 'address1', (locationData.data.results[0].components.suburb) ? locationData.data.results[0].components.suburb : locationData.data.results[0].components.suburb)
            if (country_code === "US" || country_code === "PH") {
                this.$set(this.model, 'zip_code', locationData.data.results[0].components.postcode)
            } else {
                this.$set(this.model, 'postal_code', locationData.data.results[0].components.postcode)
            }
            // this.$set(this.model, 'postal_code', locationData.data.results[0].components.postcode)

        },

        async fetchCoordinates() {
            if (this.isReadOnly) return
            let coords = {
                latitude: 0,
                longitude: 0
            }
            try {
                const {
                    country_code,
                    city,
                    address1, state
                } = this.model

                // console.log("this.model.......",this.model)
                if (!(country_code || city || address1 || state))
                    throw new Error('Invalid Address!')

                coords = await this.$store.dispatch(
                    'locations/geocodeAddress',
                    this.model
                )
            } catch (err) {
                //console.log('fetchCoordinates error', err)
            } finally {
                for (const key in coords) {
                    this.$set(this.model, key, coords[key])
                }
                this.$emit('update-location-model', {
                    ...this.model
                })
            }
        },

        capitalCase(data) {
            if (data == 'country_code') return 'Country/Region'
            if (data == 'postal_code') return 'Post Office/District Code'
            if (data == 'state_name') return 'State/Province/Region/Parish'
            const list = data.split('_')
            if (list[list.length - 1] === 'id') {
                list.pop()
            }
            return list
                .map(
                    x => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase()
                )
                .join('  ')
        },
        getData(field) {
            return (() => {
                switch (field) {
                    case 'country_code':
                        return this.$store.state.locations.country
                    case 'state_name':
                        return this.$store.state.locations.states
                }
            })()
        },


        deleteLocation() {
            const model = {
                ...this.model
            }
            this.$emit('delete-location', model.id)
        },
        async onSubmit() {
            const model = {
                ...this.model
            }

            // console.log("......model........", model)

            if (!model.latitude || !model.longitude) {
                this.doToast(
                    this.$translate('error'),
                    this.$translate("lat_long_missing_alert"),
                    'danger'
                )
                return
            }

            if (this.sectionOnly && !model.id) {
                model.name = model.name || Date.now().toString(36)
                model.is_warehouse = false
            }
            model.is_warehouse = !!model.is_warehouse
            const valid = await this.$validator.validate()

            if (!valid) {
                this.doToast(this.$translate('error'), this.$translate('invalid'), 'danger')
                return
            }
            if (valid) {
                this.$emit('save-location', model)
            }
        },
        fetchState(item, event) {
            this.model.state = null;
            const country_code = event
            this.$store.commit('locations/SET_STATES', null);
            this.$store.dispatch('locations/fetchstate', { country_code })
        },

        saveSection(section) {
            const {
                id: location_id
            } = this.simpleLocation
            this.$emit('save-section', {
                section,
                location_id
            })
        },
        deleteSection(id) {
            const location_id = this.simpleLocation.id
            this.$emit('delete-section', {
                id,
                location_id
            })
        },
    },
}
</script>
<style></style>
